import { CreateDomElement } from '../engine/viewer/domutils.js';
import { ButtonDialog } from './dialog.js';
import { Loc } from '../engine/core/localization.js';

export function CommentDialog (viewer, callback)
{
    let dialog = new ButtonDialog ();
	
	let nameLabel = CreateDomElement('label', 'ov_comment_label');
	nameLabel.innerText = Loc('Comment name');
	let nameInput = CreateDomElement('input', 'ov_comment_input_name');
	
	let commentLabel = CreateDomElement('label', 'ov_comment_label');
	commentLabel.innerText = Loc('Comment text');
	let commentArea = CreateDomElement('textarea', 'ov_comment_text_area');
	
    let contentDiv = dialog.Init (Loc ('Add comment'), [
        {
            name : Loc ('Cancel'),
            subClass : 'outline',
            onClick () {
                dialog.Close ();
            }
        },
        {
            name : Loc ('Add'),
            onClick () {
				if (nameInput.value !== '' && commentArea.value !== '') 
				{
					if (callback) 
					{
						callback(nameInput.value, commentArea.value);
					}
				}
                dialog.Close ();
            }
        }
    ]);

    let dialogDiv = dialog.GetContentDiv ();
    dialogDiv.classList.add ('ov_snapshot_dialog');
	
	contentDiv.appendChild(nameLabel);
	contentDiv.appendChild(nameInput);
	contentDiv.appendChild(commentLabel);
	contentDiv.appendChild(commentArea);

    dialog.Open ();
    return dialog;
}
